import { Star } from "lucide-react";

interface StarRatingProps {
  value: number;
  size?: "xs" | "sm" | "md";
}

const sizeMap = { xs: "h-3 w-3", sm: "h-4 w-4", md: "h-5 w-5" };

const StarRatingDisplay = ({ value, size = "sm" }: StarRatingProps) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((s) => (
      <Star
        key={s}
        className={`${sizeMap[size]} ${
          s <= Math.round(value)
            ? "fill-primary text-primary"
            : "fill-none text-muted-foreground/30"
        }`}
      />
    ))}
  </div>
);

export default StarRatingDisplay;
